import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const shellStyle = {
  zIndex: 0,
  background: 'linear-gradient(180deg, #111827 0%, #030712 100%)',
};

const gridStyle = {
  position: 'absolute',
  inset: 0,
  zIndex: -2,
  pointerEvents: 'none',
  backgroundImage:
    'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
  backgroundSize: '24px 24px',
  opacity: 0.14,
};

const glowStyle = {
  zIndex: -1,
  background:
    'radial-gradient(circle at 50% 0%, rgba(37,99,235,0.22), transparent 30%), radial-gradient(circle at 85% 35%, rgba(14,165,233,0.12), transparent 24%), linear-gradient(180deg, rgba(17,24,39,0) 0%, rgba(3,7,18,0.2) 100%)',
};

export const PageShell = ({ children }) => (
  <div className="relative min-h-screen overflow-hidden dark text-white" style={shellStyle}>
    <div aria-hidden="true" style={gridStyle} />
    <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={glowStyle} />
    <div className="site-frame relative py-8 sm:py-10">{children}</div>
  </div>
);

export const PageBackLink = ({ to = '/', onClick, children = 'Back to home' }) => (
  <Link
    to={to}
    onClick={onClick}
    className="group inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-sm font-medium text-gray-200 transition-colors hover:bg-white/[0.08] hover:text-white"
  >
    <ArrowLeft className="h-4 w-4 transition-transform duration-200 group-hover:-translate-x-0.5" />
    <span>{children}</span>
  </Link>
);

export const PageHero = ({ eyebrow, title, description }) => (
  <div className="mx-auto max-w-3xl text-center">
    {eyebrow ? <div className="text-sm uppercase tracking-[0.3em] text-blue-300">{eyebrow}</div> : null}
    <h1 className="mt-3 text-4xl font-bold text-white sm:text-5xl">{title}</h1>
    {description ? <p className="mt-4 text-lg leading-relaxed text-gray-300 sm:text-xl">{description}</p> : null}
  </div>
);

export const PagePanel = ({ className = '', children }) => (
  <div className={`rounded-2xl border border-white/10 bg-white/[0.04] p-8 shadow-2xl shadow-black/20 ${className}`.trim()}>
    {children}
  </div>
);
